class RouteModel extends App.Models.BaseModel {
  modelUrl = "Route";

  fetchWithCriteria = obj => {
    return Monet.Model.fetchWithCriteria({
      options: obj,
      model: this
    });
  };

  filterWithRestrictions = obj => {
    return Monet.Model.filterWithRestrictions({
      options: obj,
      model: this,
      body: obj.body
    });
  };

  stops = obj => {
    return Monet.Model.hasMany({
      options: obj,
      parent: this,
      collection: App.Collections.Stops,
      model: App.Models.Stop
    });
  };
}

App.Models.Route = RouteModel;
